export default function PreviewQuestionAssignmentText() {
    // Used in PreviewExerciserSideBar to display test
    // assignments

    // BUILD
    return (
        <div className={"mt-[16px] w-full px-[12px]"}>
            <ul className="w-full list-disc list-outside flex flex-col justify-start items-start space-y-[8px] text-[14px] text-greyLight9 font-normal">
                <li>
                    {"Vérifier la bonne réponse et ses explications"}
                </li>
                <li>
                    {"Vérifier les mauvaises réponses et leur explication"}
                </li>
                <li>
                    {"Afficher en mobile et vérifier que le LateX n'est pas rogné"}
                </li>
            </ul>
        </div>
    );
}